<!-- eslint-disable vue/multi-word-component-names -->
<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div v-if="LeituraCarteira">
      <div class="mb-6 ml-2">
        <h3>Resumo de cotações e propostas</h3>
      </div>

      <vx-card title="Automóvel" class="mb-10 w-full">
        <filtroResumoCotacoes
          v-if="
            LeituraCarteiraCompleta ||
            LeituraCarteiraConvenio ||
            LeituraCarteiraAssessoria
          "
          @brokerSelected="changeRegionalFilter"
        />
        <div class="vx-row flex-wrap gap-6 p-4">
          <modal-card-resumo-propostas
            :active.sync="modalResumoProposta"
            @close="modalResumoProposta = false"
            :title="modalResumoPropostaTitle"
            :statusId="modalResumoPropostaStatusId"
            :id_regional="returnIdRegional()"
            :permission="LeituraCarteiraCompleta"
            :permissionSearch="permissionSearch"
            @updateData="buscaDadosResumoCotacoes(id_regional)"
          />
          <CardResumoPropostas
            :value="this.cotacaoAberta"
            icon="ArchiveIcon"
            iconPack="material-icons"
            color="success"
            :label="customStatus.COTACAO_ABERTA.name"
            @click="openModal(customStatus.COTACAO_ABERTA)"
          />
          <CardResumoPropostas
            :value="this.processingPayment"
            icon="DollarSignIcon"
            iconPack="material-icons"
            color="warning"
            :label="STATUS_PROPOSTA.PROCESSANDO_PAGAMENTO.name"
            @click="openModal(STATUS_PROPOSTA.PROCESSANDO_PAGAMENTO)"
          />
          <CardResumoPropostas
            :value="this.aguardandoDadosCartao"
            icon="DollarSignIcon"
            iconPack="material-icons"
            color="warning"
            :label="STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO.name"
            @click="openModal(STATUS_PROPOSTA.AGUARDANDO_DADOS_CARTAO)"
          />
          <CardResumoPropostas
            :value="this.emProcessoVistoria"
            icon="CameraIcon"
            iconPack="material-icons"
            color="primary"
            :label="STATUS_PROPOSTA.EM_PROCESSO_VISTORIA.name"
            @click="openModal(STATUS_PROPOSTA.EM_PROCESSO_VISTORIA)"
          />
          <CardResumoPropostas
            :value="this.pendente"
            icon="AlertTriangleIcon"
            iconPack="material-icons"
            color="warning"
            :label="STATUS_PROPOSTA.PENDENTE.name"
            @click="openModal(STATUS_PROPOSTA.PENDENTE)"
          />
          <CardResumoPropostas
            :value="this.vistoriaExpirada"
            icon="AlertTriangleIcon"
            iconPack="material-icons"
            color="danger"
            :label="STATUS_PROPOSTA.VISTORIA_EXPIRADA.name"
            @click="openModal(STATUS_PROPOSTA.VISTORIA_EXPIRADA)"
          />
          <CardResumoPropostas
            :value="this.vistoriaAguardandoAprovacao"
            icon="ActivityIcon"
            iconPack="material-icons"
            color="primary"
            :label="STATUS_PROPOSTA.AGUARDANDO_APROVACAO.name"
            @click="openModal(STATUS_PROPOSTA.AGUARDANDO_APROVACAO)"
          />
          <CardResumoPropostas
            :value="this.finalizada"
            icon="CheckIcon"
            iconPack="material-icons"
            color="dark"
            subtitle="Últimos 30 dias"
            :label="STATUS_PROPOSTA.FINALIZADO.name"
            @click="openModal(STATUS_PROPOSTA.FINALIZADO, true)"
          />
          <CardResumoPropostas
            :value="this.recusada"
            icon="XSquareIcon"
            iconPack="material-icons"
            color="danger"
            subtitle="Últimos 30 dias"
            :label="customStatus.RECUSADA.name"
            @click="openModal(customStatus.RECUSADA)"
          />
          <CardResumoPropostas
            :value="this.cotacaoRecusada"
            icon="XSquareIcon"
            iconPack="material-icons"
            color="danger"
            subtitle="Últimos 30 dias"
            :label="customStatus.COTACAO_RECUSADA.name"
            @click="openModal(customStatus.COTACAO_RECUSADA)"
          />
          <CardResumoPropostas
            v-if="canViewRenewals"
            :value="renewalsNext30Days"
            icon="RepeatIcon"
            iconPack="material-icons"
            color="success"
            label="Renovações"
            subtitle="Próximos 30 dias"
            @click="goToRenewals"
          />
        </div>
      </vx-card>
    </div>

    <div v-if="LeituraFinanceiro || LeituraFinanceiroCompleta">
      <div class="mb-6 ml-2">
        <h3>Financeiro</h3>
      </div>
      <DashboardFinancial :completePermission="!!LeituraFinanceiroCompleta" />
    </div>
    <ModalNews />
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import CardResumoPropostas from './component/card-resumo-propostas.vue';
import filtroResumoCotacoes from '../filtros/FiltroResumoPropostasDashboard.vue';
import modalCardResumoPropostas from './component/modal-card-resumo-propostas.vue';
import DashboardFinancial from './component/DashboardFinancial/DashboardFinancial.vue';
import { STATUS_PROPOSTA, ALL_BROKERS_OPTION } from '../../utils/constants.js';
import { RENEWALS_WINDOW_DAYS } from '@/constants/renewals';
import {
  PERMISSIONS_ACTIONS,
  PERMISSIONS_NAMES,
} from '@/constants/permissions';
import reportsApi from '@/services/reports.api';
import renewalsApi from '@/services/renewals.api';
import ModalNews from '../modais/ModalNews.vue';

export default {
  computed: {
    LeituraCarteira() {
      return (
        this.$can('Leitura Carteira Corretora', 'Dashboard') ||
        this.$can('Leitura Carteira Assessoria', 'Dashboard') ||
        this.$can('Leitura Carteira Convênio', 'Dashboard') ||
        this.$can('Leitura Carteira Completa', 'Dashboard')
      );
    },
    LeituraCarteiraCorretora() {
      return this.$can('Leitura Carteira Corretora', 'Dashboard');
    },
    LeituraCarteiraConvenio() {
      return this.$can('Leitura Carteira Convênio', 'Dashboard');
    },
    LeituraCarteiraAssessoria() {
      return this.$can('Leitura Carteira Assessoria', 'Dashboard');
    },
    LeituraCarteiraCompleta() {
      return this.$can('Leitura Carteira Completa', 'Dashboard');
    },
    LeituraFinanceiro() {
      return this.$can('Leitura Financeiro', 'Dashboard');
    },
    LeituraFinanceiroCompleta() {
      return this.$can('Leitura Financeiro Completa', 'Dashboard');
    },
    canViewRenewals() {
      return (
        this.$can(PERMISSIONS_ACTIONS.READ, PERMISSIONS_NAMES.RENEWALS) ||
        this.canViewAllRenewals
      );
    },
    canViewAllRenewals() {
      return this.$can(
        PERMISSIONS_ACTIONS.WALLET_COMPLETE_READ,
        PERMISSIONS_NAMES.RENEWALS,
      );
    },
  },
  data() {
    return {
      STATUS_PROPOSTA,
      customStatus: {
        RECUSADA: {
          ...STATUS_PROPOSTA.RECUSADA,
          name: 'Propostas Recusadas',
        },
        COTACAO_RECUSADA: {
          ...STATUS_PROPOSTA.COTACAO_RECUSADA,
          name: 'Cotações Recusadas',
        },
        COTACAO_ABERTA: { ...STATUS_PROPOSTA.COTACAO_ABERTA, name: 'Cotação' },
      },
      decoded: null,
      permissionVisualizarDados: this.$can('Visualizar Dados', 'Dashboard'),
      cotacaoAberta: 0,
      aguardandoDadosCartao: 0,
      processingPayment: 0,
      emProcessoVistoria: 0,
      pendente: 0,
      recusada: 0,
      finalizada: 0,
      vistoriaAguardandoAprovacao: 0,
      vistoriaExpirada: 0,
      cotacaoRecusada: 0,
      id_regional: null,
      modalResumoProposta: false,
      modalResumoPropostaTitle: '',
      modalResumoPropostaStatusId: 0,
      permissionSearch: false,
      renewalsNext30Days: 0,
    };
  },
  methods: {
    formatDateYMD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    renewalsWindow() {
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      const end = new Date(start);
      end.setDate(end.getDate() + RENEWALS_WINDOW_DAYS);
      return {
        endValidityStart: this.formatDateYMD(start),
        endValidityEnd: this.formatDateYMD(end),
      };
    },
    async fetchRenewalsCount(idRegional) {
      if (!idRegional) {
        this.renewalsNext30Days = 0;
        return;
      }
      const isAllBrokers = Number(idRegional) === ALL_BROKERS_OPTION.ID;
      if (isAllBrokers && !this.canViewAllRenewals) {
        this.renewalsNext30Days = 0;
        return;
      }
      try {
        const { endValidityStart, endValidityEnd } = this.renewalsWindow();
        const payload = {
          endValidityStart,
          endValidityEnd,
          page: 1,
          itemsPerPage: 1,
        };
        if (!isAllBrokers) payload.brokers = [idRegional];
        const data = await renewalsApi.getRenewals(payload);
        this.renewalsNext30Days = data.total || 0;
      } catch (error) {
        this.renewalsNext30Days = 0;
      }
    },
    goToRenewals() {
      if (!this.id_regional) {
        this.$router.push({ path: '/auto/renovacoes' });
        return;
      }
      const query = { ...this.renewalsWindow() };
      if (Number(this.id_regional) !== ALL_BROKERS_OPTION.ID) {
        query.brokers = this.id_regional;
      }
      this.$router.push({ path: '/auto/renovacoes', query });
    },
    getDecoded() {
      const token = localStorage.getItem('user-token');
      if (token) {
        this.decoded = jwt.decode(token);
      }
      this.id_usuario = this.decoded.id_usuario;
      this.id_empresa = this.decoded.id_empresa;
      if (
        this.decoded.id_regional &&
        this.LeituraCarteiraCorretora &&
        !this.LeituraCarteiraCompleta
      ) {
        this.id_regional = this.decoded.id_regional;
      }
    },
    async buscaDadosResumoCotacoes(idRegional, { skipLoading = false } = {}) {
      if (!idRegional) {
        this.cotacaoAberta = 0;
        this.aguardandoDadosCartao = 0;
        this.processingPayment = 0;
        this.emProcessoVistoria = 0;
        this.pendente = 0;
        this.recusada = 0;
        this.finalizada = 0;
        this.vistoriaAguardandoAprovacao = 0;
        this.vistoriaExpirada = 0;
        this.cotacaoRecusada = 0;
        return;
      }

      try {
        if (!skipLoading) this.$vs.loading();
        const data = await reportsApi.getAutoQuotationsCount(idRegional);

        const {
          cotacaoAberta,
          aguardandoDadosCartao,
          processingPayment,
          emProcessoVistoria,
          pendente,
          recusada,
          finalizada,
          vistoriaAguardandoAprovacao,
          vistoriaExpirada,
          cotacaoRecusada,
        } = data;

        this.cotacaoAberta = cotacaoAberta;
        this.aguardandoDadosCartao = aguardandoDadosCartao;
        this.processingPayment = processingPayment;
        this.emProcessoVistoria = emProcessoVistoria;
        this.pendente = pendente;
        this.recusada = recusada;
        this.finalizada = finalizada;
        this.vistoriaAguardandoAprovacao = vistoriaAguardandoAprovacao;
        this.vistoriaExpirada = vistoriaExpirada;
        this.cotacaoRecusada = cotacaoRecusada;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        if (!skipLoading) this.$vs.loading.close();
      }
    },
    openModal(status, lastMonthOnly) {
      if (!this.id_regional) return;
      const subtitle = lastMonthOnly ? ' - Últimos 30 dias' : '';
      this.modalResumoPropostaTitle = status.name + subtitle;
      this.modalResumoPropostaStatusId = status.id;
      this.modalResumoProposta = true;
    },
    returnIdRegional() {
      const id_regional = this.id_regional
        ? this.id_regional
        : this.decoded.id_regional;
      return id_regional;
    },
    async changeRegionalFilter(id_regional) {
      this.id_regional = id_regional;
      this.permissionSearch = true;
      this.$vs.loading();
      try {
        await this.buscaDadosResumoCotacoes(id_regional, {
          skipLoading: true,
        });
        if (this.canViewRenewals) {
          await this.fetchRenewalsCount(id_regional);
        }
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  components: {
    filtroResumoCotacoes,
    CardResumoPropostas,
    modalCardResumoPropostas,
    DashboardFinancial,
    ModalNews,
  },
  async created() {
    this.getDecoded();

    const shouldLoadCotacoes =
      this.id_regional &&
      this.LeituraCarteiraCorretora &&
      !this.LeituraCarteiraCompleta;

    if (!shouldLoadCotacoes) {
      if (this.canViewRenewals) {
        this.fetchRenewalsCount(this.id_regional);
      }
      return;
    }

    this.$vs.loading();
    try {
      await this.buscaDadosResumoCotacoes(this.id_regional, {
        skipLoading: true,
      });
      if (this.canViewRenewals) {
        await this.fetchRenewalsCount(this.id_regional);
      }
    } finally {
      this.$vs.loading.close();
    }
  },
};
</script>
